module.exports = __webpack_public_path__ + "fonts/subset-MullerLight.882bc2f6.woff2";